module.exports = __webpack_public_path__ + "static/front/img/banner-2.b583d880.jpg";